<template>
  <v-container>
    <v-flex xs12>
      <v-card color="grey lighten-2">

        <v-card-title v-if="spotID">{{spots[spotID-1].title}} </v-card-title>

  
        <v-layout row v-if="pic">          
            <v-flex xs1  mx-4 >
              <v-btn color="orange lighten-2" style="top:38%; float: left; "  @click="i++;"  >
                <v-icon> arrow_left </v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs2  mx-2 v-if="pic">
             <v-card   height="150px" style="width:100%; top:15%;" color="grey lighten-1" >
                <img  height="150px" width="100%" :src="pic.infoPicture" contain alt="STATIC IMAGE">
              </v-card>
            </v-flex>
            <v-flex xs4  mx-2  v-if="pic1">
              <v-card height="200px" style="width:100%;" color="grey lighten-1" >
                <img  height="200px" width="100%" :src="pic1.infoPicture" contain alt="STATIC IMAGE">
              </v-card>
            </v-flex>
            <v-flex xs2  mx-2 v-if="pic2">
              <v-card height="150px" style="width:100%; top:15%;" color="grey lighten-1" >
                 <img  height="150px" width="100%" :src="pic2.infoPicture" alt="STATIC IMAGE" contain>
              </v-card>
            </v-flex>
            <v-flex xs1   ml-4 >
              <v-btn color="orange lighten-2" style="top:38%; float: right; " @click="i--;"  >
                <v-icon> arrow_right </v-icon>
              </v-btn>
            </v-flex>
        </v-layout>    
      


        <v-layout column pa-4>

          <v-layout row>
            <v-flex xs2 class="hidden-xs-only">
              <v-btn color="orange lighten-2" @click="id--;" style="top:40%;">
                <v-icon>arrow_left </v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs8>
              <v-card height="250px" style="width:200%;" color="grey lighten-1" v-if="text">
                <v-card-text pa-3>
                  <p> {{text.infoTText}} </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs8>
               <v-card height="250px" style="width:200%;" color="grey lighten-1" v-if="!text">
                <v-card-text pa-3>
                  <p> No text </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs2 class="hidden-xs-only">
              <v-btn color="orange lighten-2" @click="id++;" style="top:40%">
                <v-icon>arrow_right </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row class="hidden-sm-and-up">
            <v-flex xs6>
              <v-btn color="orange lighten-2" @click="id--;">
                <v-icon>arrow_left </v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn color="orange lighten-2" @click="id++;">
                <v-icon>arrow_right </v-icon>
              </v-btn>
            </v-flex>
            
          </v-layout>
        </v-layout>
        <v-layout>
            <v-flex xs1  mx-4 >
              <v-btn color="orange lighten-2" style="top:38%; float: left; "  @click="e++;"  >
                <v-icon> arrow_left </v-icon>
              </v-btn>
            </v-flex>
         
          <v-flex xs8  mx-4>
              <v-card height="250px" style="width:100%;" color="grey lighten-1" v-if="que">
                <v-card-text pa-3>
                  <p style="font-size:120%;"><b> Question :  {{que.question}} </b></p>
                  <p  v-for="(item, index) in que.options" :key="index" >{{index+1}} : {{item}}</p>
                 
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs1   ml-4 >
              <v-btn color="orange lighten-2" style="top:38%; float: right; " @click="e--;"  >
                <v-icon> arrow_right </v-icon>
              </v-btn>
            </v-flex>
        </v-layout>


        <v-flex>
          <v-radio-group v-model="l" :mandatory="true">
      <v-radio label="English" value="1"></v-radio>
      <v-radio label="Greek" value="2"></v-radio>
    </v-radio-group>
        </v-flex>
      </v-card>
    </v-flex>

  </v-container>
</template>


<script>
  export default {
    data() {
      return {
        l: '1',
        id: 0,
        i:0,
        j:0,
        k:0,
        e:0
      };
    },
    props: [],
    computed: {
      texts(){
        var textL = [[],[]]
        var texts= this.$store.getters.pointTexts;
        texts.forEach(el => {
          if(el.infoTLang === 1){
            textL[0].push(el);
          }
          else{
             textL[1].push(el);
          }
        });
        return textL;
      },
      ques(){
        var queL = [[],[]]
        var ques = this.$store.getters.pointQuestions;
         ques.forEach(el => {
          if(el.language === 1){
            queL[0].push(el);
          }
          else{
             queL[1].push(el);
          }
        });
        return queL;
      },
      que(){
        var que;
        if (this.e > this.ques[Number(this.l)-1].length - 1) {
          this.e = 0;
        } else if (this.e < 0) {
          this.e = this.ques[Number(this.l)-1].length - 1;
        }
        que = this.ques[(Number(this.l)-1) ] [this.e];
        return que;
      },
      pics() {
        var pics =  this.$store.getters.pointPics;
        var picL = [[],[]];
        pics.forEach(el => {
          if(el.infoPLang === 1){
            picL[0].push(el);
          }
          else{
             picL[1].push(el);
          }
        });
        return picL

      },
      pic(){
        var pic
        if (this.i > this.pics[Number(this.l-1)].length - 1) {
          this.i = 0;
        } else if (this.i < 0) {
          this.i = this.pics[Number(this.l-1)].length - 1;
        }
        pic = this.pics[Number(this.l-1)][this.i];
        return pic;
      },
        pic1(){
        var pic
        this.j = this.i+1;
        if (this.j > this.pics[Number(this.l-1)].length - 1) {
          this.j = 0;
        } else if (this.j < 0) {
          this.j = this.pics[Number(this.l-1)].length - 1;
        }
        pic = this.pics[Number(this.l-1)][this.j];
        return pic;
      },
        pic2(){
        var pic
         this.k = this.j+1;
        if (this.k > this.pics[Number(this.l-1)].length - 1) {
          this.k = 0;
        } else if (this.k < 0) {
          this.k = this.pics[Number(this.l-1)].length - 1;
        }
        pic = this.pics[Number(this.l-1)][this.k];
        return pic;
      },
      text() {
        var text;
        if (this.id > this.texts[Number(this.l)-1].length - 1) {
          this.id = 0;
        } else if (this.id < 0) {
          this.id = this.texts[Number(this.l)-1].length - 1;
        }
        text = this.texts[(Number(this.l)-1) ] [this.id];
        return text;
      },
      spots(){
        return this.$store.getters.points
      },
       spotID(){
       return  this.$route.params.id;
      }
    },
    methods: {
      
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/preview.vue